
import AppLayout from '../../components/layout/app-layout/app-layout';
import Tabs from '../../components/shared/Tabs';
import { FC, useMemo, useState } from 'react';
import styles from './page-help.module.scss';
import { useTranslation } from 'react-i18next';
import { videoCollections } from './videoConfig';
import Playlist from './playlist';

const PageHelp: FC = () => {
  const [t] = useTranslation('help');
  const [selectedTab, setSelectedTab] = useState(0);

  const collections = useMemo(() => 
    videoCollections.map(collection => ({
      ...collection,
      title: t(`${collection.nameKey}.title`, 'Kom igång med Accurator'),
      intro: t(`${collection.nameKey}.intro`, 'Filmerna i denna samling går igenom inköpsprocessen i Accurator. Använd menyn i spelaren för att välja film.')
    })), [t]);

  const allTabs = [
    ...collections.map(x => x.title),
    t('faq.title', 'FAQ')
  ];
  
  const selectedCollection = collections[selectedTab];
  const isFaqTab = selectedTab === collections.length;



  return (
    <AppLayout title={t('pageTitle', 'Instruktionsfilmer')}>
      <div className={styles.pageHelp}>
        <Tabs tabs={allTabs} selected={selectedTab} onChange={setSelectedTab} />
        { isFaqTab ? (
          <div className={styles.container}>
            <p>{t('faq.intro', '')}</p>
            <div className={styles.videoFrame}>
              <iframe 
                src="https://vimeo.com/showcase/10067308/embed"
                width="100%"
                height="600"
                frameBorder="0"
                allowFullScreen
                title="Accurator FAQ"
              />
            </div>
          </div>
        ) : selectedCollection && (
          <div className={styles.container}>
            <Playlist
              title={selectedCollection.title}
              description={selectedCollection.intro}
              items={selectedCollection.playlistItems || []}
            />
          </div>
        )}
      </div>
    </AppLayout>
  );
};

export default PageHelp;
